import { DataSourceExecutionEvent, Snackbar } from "@mcleod/components";
import { Navigation, StringUtil } from "@mcleod/core";
import { AutogenLayoutCRMActivities } from "./autogen/AutogenLayoutCRMActivities";

export class CRMActivities extends AutogenLayoutCRMActivities {

    panelPastDueOnClick() {
        Navigation.navigateTo('lme/crm/CRMMultiProfile?filter=P');
    }

    panelDueTodayOnClick() {
       Navigation.navigateTo('lme/crm/CRMMultiProfile?filter=T');
    }

    totalOnClick() {
        Navigation.navigateTo('lme/crm/CRMMultiProfile');
    }

    sourceProspectiveSalesLookupAfterExecution(event: DataSourceExecutionEvent) {
        const message = this.mainDataSource?.data[0]?.get("message");
        if (!StringUtil.isEmptyString(message)) {
            Snackbar.showWarningSnackbar(message);
        } else {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            
            this.labelTotalCount.text = this.mainDataSource.data.length.toString();
            
            this.labelDueTodayCount.text = this.mainDataSource.data.filter((modelRow) => {
                const dueDate = modelRow.getDate("date_due");
                if (!dueDate) return false;
                const dueDateOnly = new Date(dueDate);
                dueDateOnly.setHours(0, 0, 0, 0);
                return dueDateOnly.getTime() === today.getTime();
            }).length.toString();
            
            this.labelPastDueCount.text = this.mainDataSource.data.filter((modelRow) => {
                const dueDate = modelRow.getDate("date_due");
                if (!dueDate) return false;
                const dueDateOnly = new Date(dueDate);
                dueDateOnly.setHours(0, 0, 0, 0);
                return dueDateOnly.getTime() < today.getTime();
            }).length.toString();
        }
    }
}